import { ProjectForm } from '../../project/models/form.model';
import { formTypes } from '../../form/form.constants';
import { BusinessInformation } from './business-information.model';
import { ResearchAndDevelopmentInformation } from './research-and-development-information.model';
import { Lqre100Calculation } from './lqre100-calculation.model';
import { ManagerTaxCreditCalculation } from './manager-tax-credit-calculation.model';
import { CreditIssuance } from './credit-issuance.model';
import { RdFormType } from './rd-form-type';

export class Lqre100Application extends ProjectForm {
  type: RdFormType;
  businessInformation: BusinessInformation;
  researchAndDevelopmentInformation: ResearchAndDevelopmentInformation;
  taxCreditCalculation: Lqre100Calculation;
  managerTaxCreditCalculation: ManagerTaxCreditCalculation;
  creditIssuance: CreditIssuance;

  constructor(formIndex: number = null) {
    super(formIndex);
    this.init();
  }

  init(): Lqre100Application {
    super.init();
    this.type = <RdFormType>formTypes.rdLqre100.abbrev;

    this.businessInformation = this.businessInformation || new BusinessInformation();
    this.researchAndDevelopmentInformation = this.researchAndDevelopmentInformation || new ResearchAndDevelopmentInformation();
    this.taxCreditCalculation = this.taxCreditCalculation || new Lqre100Calculation();
    this.managerTaxCreditCalculation =
      this.managerTaxCreditCalculation || new ManagerTaxCreditCalculation();
    this.creditIssuance = this.creditIssuance || new CreditIssuance();

    return this;
  }

  get qualifier(): string {
    return null;
  }
}
